// src/components/ui/Table/TableRow.tsx
import { TableColumn } from './Table';
import { TableCell } from './TableCell';
import styles from './TableRow.module.css';

interface TableRowProps<T> {
  item: T;
  index: number;
  columns: TableColumn<T>[];
  onClick?: () => void;
  className?: string;
  columnWidths?: Record<string, number>;
  compactMode?: boolean; // Новый параметр для компактного режима
}

export function TableRow<T>({
  item,
  index,
  columns,
  onClick,
  className = '',
  columnWidths = {},
  compactMode = false
}: TableRowProps<T>) {
  // Определяем классы для строки
  const clickableClass = onClick ? styles.clickable : '';
  const compactClass = compactMode ? styles.compact : styles.regular;
  
  return (
    <tr 
      className={`${styles.row} ${clickableClass} ${compactClass} ${className}`}
      onClick={onClick}
    >
      {columns.map((column) => {
        // Получаем ширину столбца
        const width = columnWidths[column.key as string];
        
        return (
          <TableCell 
            key={column.key as string}
            column={column}
            item={item}
            index={index}
            width={width}
            compactMode={compactMode}
          />
        );
      })}
    </tr>
  );
}

export default TableRow;